import { Badge } from 'antd';

import clsx from 'clsx';
import { useMemo } from 'react';
import { SubCategoryTipStatisticsData } from '../../../../../../hooks/api/subCategoryTip';
import { SubCategoryStatisticDisplayMode } from '../../../../../../store/subCategory';

import styles from './index.module.scss';

interface AverageProps {
  subCategoryTipStatisticsData: SubCategoryTipStatisticsData | null;
  light?: boolean;
  displayMode: SubCategoryStatisticDisplayMode;
}

const displayLabel = (
  value: number,
  displayModeProp: SubCategoryStatisticDisplayMode,
) => (displayModeProp === 'percent'
  ? `${Math.round(value)}%`
  : `$${Math.round(value)}`);

function Average({
  subCategoryTipStatisticsData,
  light,
  displayMode,
}: AverageProps) {
  const value: { customer: number; worker: number } = useMemo(
    () => ({
      customer:
        displayMode === 'percent'
          ? subCategoryTipStatisticsData?.customerAvgPercent || 0
          : subCategoryTipStatisticsData?.customerAvgValue || 0,
      worker:
        displayMode === 'percent'
          ? subCategoryTipStatisticsData?.workerAvgPercent || 0
          : subCategoryTipStatisticsData?.customerAvgValue || 0,
    }),
    [subCategoryTipStatisticsData, displayMode],
  );

  if (
    !(
      (subCategoryTipStatisticsData?.customerAvgPercent || 0) > 0
      || (subCategoryTipStatisticsData?.customerAvgValue || 0) > 0
      || (subCategoryTipStatisticsData?.workerAvgPercent || 0) > 0
      || (subCategoryTipStatisticsData?.workerAvgValue || 0) > 0
    )
  ) {
    return null;
  }

  return (
    <div className={clsx(styles.wrapper, light && styles.light)}>
      <Badge
        color="linear-gradient(225deg, #6FEF92 0%, #32B238 100%)"
        text={`Average Customer Tip: ${displayLabel(
          value.customer,
          displayMode,
        )}`}
        className={styles.badge}
      />
      <Badge
        color="linear-gradient(225deg, #EBEFF3 0%, #B6C2CD 100%)"
        text={`Average Worker Tip: ${displayLabel(value.worker, displayMode)}`}
        className={styles.badge}
      />
    </div>
  );
}

export default Average;
